import { UniverseEnum } from '../../api/dashboard/universeEnum';
import { SuggestedContractViewModel } from './contracts-options/suggested-contract.view-model';
import { ContractsViewModel } from './contracts.view-model';

export class CrossroadsViewModel {
    public contracts: ContractsViewModel[] = [];
    public suggestedContracts: SuggestedContractViewModel[] = [];
    public isVimEligible = false;
    public forbidden = true;
    public universe: UniverseEnum;
}
